import { render, staticRenderFns } from "./bottomNav.vue?vue&type=template&id=8cd4f0e4"
import script from "./bottomNav.vue?vue&type=script&lang=js"
export * from "./bottomNav.vue?vue&type=script&lang=js"
import style0 from "./bottomNav.vue?vue&type=style&index=0&id=8cd4f0e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports